export { SearchViewModeProvider as ViewModeProvider, useSrpViewMode } from '../../_shell/SearchViewModeContext';
